import React, { FC } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

// 旧・利用統計ページ。統計ページ (/portal/metrics) への統合に伴いリダイレクトのみ残す。
// 旧タブの対応: 利用状況/実績推移 → 概況、薬局別比較 → 比較。他のURLパラメータは引き継ぐ
export const MetricsUsagePage: FC = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  params.set(
    'tab',
    params.get('tab') === 'comparison' ? 'comparison' : 'overview'
  )
  return <Navigate to={`/portal/metrics?${params.toString()}`} replace />
}
